import QueryString from "qs";
import dynamic from "next/dynamic";
import { GetServerSideProps } from "next";
const IndustryPageNew = dynamic(() => import("@/Components/pages/Industries"), {
  ssr: true,
});

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

interface IndustryProps {
  apiResData?: any;
  slug: string;
  blocksData?: any;
  seoData?: any;
  isNew?: boolean;
  isMobile: boolean;
  isOldPagev14: boolean;
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const userAgent = ctx.req.headers["user-agent"] || "";
  const isMobile =
    /iphone|ipod|android.*mobile|blackberry|iemobile|opera mini/i.test(
      userAgent
    );

  let isOldPagev14 = false;
  let isNew = false;

  const slug = ctx.params?.slug as string;

  const query = QueryString.stringify(
    {
      filters: { slug: { $eq: slug } },
      populate: "deep,8",
    },
    { encodeValuesOnly: false }
  );

  let apiRes = await fetch(
    `${baseUrl}manufacturings?${decodeURIComponent(query)}`
  );

  let apiResData = await apiRes.json();
  if (apiResData?.data?.length === 0) return { notFound: true };

  let listData = apiResData?.data;

  /* Remove When All pages are ready --- start */
  if (!listData?.length) {
    apiRes = await fetch(`${baseUrl}industries?${decodeURIComponent(query)}`);
    apiResData = await apiRes.json();

    listData = apiResData?.data;
    isOldPagev14 = true;
    isNew = listData?.template === "main-v2"; // Extract isNew from server-side
  }
  /* Remove When All pages are ready --- start */

  return {
    props: {
      apiResData,
      slug,
      isNew,
      isOldPagev14,
      isMobile,
    },
  };
};

const Industry: React.FC<IndustryProps> = ({ isMobile, apiResData }) => {
  const listData = apiResData?.data[0].attributes || [];
  const blocksData = listData.blocks;
  const seoData = listData.seo[0] || null;
  const breadcrumbs = listData.breadcrumbs;

  return (
    <IndustryPageNew
      blocks={blocksData}
      isMobile={isMobile}
      seo={seoData}
      breadcrumbs={breadcrumbs}
    />
  );
};

export default Industry;
